// extracted by mini-css-extract-plugin
export default {"wrapper":"ScrollDown_wrapper__BOhju","scrolldown":"ScrollDown_scrolldown__ZawcW","line":"ScrollDown_line__M27jv"};